import { publicApiUrl } from "./api";
import { getActiveAssignments } from "./experiments";

// Cliente de eventos minimo - T1 do backlog de conversao (auditoria de oferta):
// sem isso, nao existia nenhuma visibilidade de onde o funil de assinatura
// perde gente. Dispara pro nosso proprio backend (api/events.js -> DynamoDB),
// sem servico externo. Fire-and-forget de proposito: uma falha de rede ou de
// storage aqui NUNCA pode quebrar ou atrasar a experiencia de quem esta
// navegando ou comprando.
const ALLOWED_EVENTS = new Set([
  "page_view",
  "plan_view",
  "checkout_started",
  "purchase_completed",
  "experiment_exposure",
  "cta_click",
  "signup_started",
  "signup_completed",
  "paywall_view",
  "paywall_click",
  "tool_used",
  "tool_cta_click",
]);

const ANON_ID_KEY = "qa_anon_id";

function getAnonId() {
  try {
    let id = window.localStorage.getItem(ANON_ID_KEY);
    if (!id) {
      id = `anon_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(ANON_ID_KEY, id);
    }
    return id;
  } catch {
    // Storage bloqueado (aba anonima, config de privacidade) - o evento
    // ainda e util agregado, so nao da pra juntar na mesma sessao.
    return null;
  }
}

export function trackEvent(event, properties = {}) {
  if (!ALLOWED_EVENTS.has(event)) return;
  if (typeof window === "undefined") return;

  let payload;
  try {
    payload = JSON.stringify({
      event,
      // Variantes de A/B ativas (T4) entram em toda evento automaticamente -
      // nenhum call-site de trackEvent precisa saber que um experimento existe.
      properties: { ...getActiveAssignments(), ...properties },
      anonId: getAnonId(),
      path: window.location?.pathname || null,
      referrer: document.referrer || null,
    });
  } catch {
    return;
  }

  try {
    const url = publicApiUrl("/api/events");

    // sendBeacon sobrevive a navegacao/fechamento de aba (importante pro
    // checkout_started, disparado bem antes de abrir a janela de pagamento) -
    // fetch com keepalive fica de fallback pra navegadores sem suporte.
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      const sent = navigator.sendBeacon(url, blob);
      if (sent) return;
    }

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Nunca deixar tracking quebrar a pagina.
  }
}
